"use client";

import React from "react";
import { cn } from "@/utils/utils";

export type BadgeColor = "red" | "blue" | "green" | "purple" | "gray";

interface RemovableBadgeProps {
  label: string;
  onRemove?: () => void;
  color?: BadgeColor;
  className?: string;
}

const getColorStyles = (color: BadgeColor) => {
  switch (color) {
    case "red":
      return {
        badge: "bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100",
        button:
          "text-red-600 hover:text-red-800 dark:text-red-200 dark:hover:text-white",
      };
    case "blue":
      return {
        badge: "bg-blue-100 text-blue-800 dark:bg-blue-800 dark:text-blue-100",
        button:
          "text-blue-600 hover:text-blue-800 dark:text-blue-200 dark:hover:text-white",
      };
    case "green":
      return {
        badge:
          "bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100",
        button:
          "text-green-600 hover:text-green-800 dark:text-green-200 dark:hover:text-white",
      };
    case "purple":
      return {
        badge:
          "bg-purple-100 text-purple-800 dark:bg-purple-800 dark:text-purple-100",
        button:
          "text-purple-600 hover:text-purple-800 dark:text-purple-200 dark:hover:text-white",
      };
    default:
      return {
        badge: "bg-gray-100 text-gray-800 dark:bg-slate-500 dark:text-white",
        button:
          "text-gray-600 hover:text-gray-800 dark:text-gray-200 dark:hover:text-white",
      };
  }
};

export function RemovableBadge({
  label,
  onRemove,
  color = "gray",
  className,
}: RemovableBadgeProps) {
  const styles = getColorStyles(color);

  return (
    <span
      className={cn(
        "px-3 py-1 rounded-full text-sm flex items-center gap-1 capitalize",
        styles.badge,
        className,
      )}
    >
      {label}
      {onRemove && (
        <button
          aria-label={`Remove ${label}`}
          className={cn("ml-1", styles.button)}
          onClick={onRemove}
          type="button"
        >
          ×
        </button>
      )}
    </span>
  );
}
